"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagsUpdateSchema = exports.TagsUpdateScalarSchema = exports.TagsCreateSchema = exports.TagsCreateScalarSchema = exports.TagsPrismaUpdateSchema = exports.TagsPrismaCreateSchema = exports.TagsSchema = exports.TagsScalarSchema = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const TagLang_schema_1 = require("../enums/TagLang.schema");
const baseSchema = zod_1.z.object({
    id: zod_1.z.string().min(3).max(15).regex(new RegExp("^[a-z]+$")),
    lang: TagLang_schema_1.TagLangSchema,
}).strict();
const relationSchema = zod_1.z.object({
    merchantTags: zod_1.z.array(zod_1.z.unknown()).optional(),
});
/**
 * `Tags` schema excluding foreign keys and relations.
 */
exports.TagsScalarSchema = baseSchema;
/**
 * `Tags` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.TagsSchema = exports.TagsScalarSchema.merge(relationSchema.partial());
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.TagsPrismaCreateSchema = baseSchema.partial().passthrough();
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.TagsPrismaUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().min(3).max(15).regex(new RegExp("^[a-z]+$")),
    lang: TagLang_schema_1.TagLangSchema
}).partial().passthrough();
/**
 * `Tags` schema for create operations excluding foreign keys and relations.
 */
exports.TagsCreateScalarSchema = baseSchema;
/**
 * `Tags` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.TagsCreateSchema = baseSchema;
/**
 * `Tags` schema for update operations excluding foreign keys and relations.
 */
exports.TagsUpdateScalarSchema = baseSchema.partial();
/**
 * `Tags` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.TagsUpdateSchema = exports.TagsUpdateScalarSchema;
